import { Component, Input } from '@angular/core';

@Component({
    selector: 'clink-select-column',
    templateUrl: 'select-column.component.html',
    styleUrls: [`select-column.component.less`],
})
export class SelectColumnComponent {
    @Input() displayTitle = '显示字段'; // 选中标题
    @Input() hiddenTitle = '隐藏字段'; // 未选中标题
    @Input() submitted = false; // 是否已保存
    @Input() classifyObj = { showArr: [], hiddenArr: [] }; // 展示数据组
    @Input() labelKey = 'name'; // 比较值
    @Input() valueKey = 'name'; // 比较值

    constructor() {}

    /**
     * 复选框点击事件
     *
     * @param {*} event
     * @param {*} item
     * @param {*} i
     * @memberof SelectColumnComponent
     */
    changeCheckBox(event: boolean, item: any, i: number): void {
        if (event) {
            // 未显示 ---> 显示
            item.show = true;
            this.classifyObj.hiddenArr.splice(i, 1);
            this.classifyObj.showArr.push(item);
        } else {
            // 显示 ---> 未显示
            item.show = false;
            this.classifyObj.showArr.splice(i, 1);
            this.classifyObj.hiddenArr.push(item);
        }
    }
}
